import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Paper,
  Typography,
  Button,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  InputAdornment,
} from "@mui/material";
import axios from "axios";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { localeTextVietnamese } from "../../utils/localeText-vn";
import { toast } from "react-toastify";
import swal from "sweetalert";

const paginationModel = { page: 1, pageSize: 10 };

export default function UserPage() {
  const [rows, setRows] = React.useState([]);
  const [roles, setRoles] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [isResetPassword, setIsResetPassword] = React.useState(false);
  const [formData, setFormData] = React.useState({
    roleId: 0,
    userCode: ``,
    fullName: ``,
    email: ``,
    phone: ``,
    address: ``,
    account: ``,
    password: ``,
  });
  const [errors, setErrors] = React.useState({});
  const [showPassword, setShowPassword] = React.useState(false);

  // setting column
  const columns = [
    { field: "index", headerName: "STT", width: 100 },
    // { field: "roleId", headerName: "Quyền", width: 130 },
    { field: "fullName", headerName: "Họ và tên", flex: 3 },
    { field: "email", headerName: "Email", flex: 3 },
    { field: "phone", headerName: "Số điện thoại", flex: 3 },
    { field: "address", headerName: "Địa chỉ", flex: 3 },
    { field: "account", headerName: "Tên tài khoản", flex: 2 },
    {
      field: "action",
      headerName: "Thao tác",
      description: "",
      sortable: false,
      flex: 5,
      renderCell: (params) => (
        <Box
          sx={{ display: "flex", gap: 1, alignItems: "center", height: "100%" }}
        >
          <Button
            variant="contained"
            color="info"
            onClick={(event) => {
              event.stopPropagation();
              handleResetPassword(params.row);
            }}
          >
            Đặt lại mật khẩu
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={(event) => {
              event.stopPropagation();
              handleEdit(params.row);
            }}
          >
            Chỉnh sửa
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={(event) => {
              event.stopPropagation();
              handleDelete(params.id);
            }}
          >
            Xoá
          </Button>
        </Box>
      ),
    },
  ];

  const handleEdit = (row) => {
    handleOpen(row);
  };

  const handleResetPassword = (row) => {
    handleOpen(row);
    setIsResetPassword(true);
  };

  const userId = localStorage.getItem("userId");
  React.useEffect(() => {
    getData();
    getDataRole();
  }, []);

  const getData = () => {
    axios
      .get(`/api/v1/users`, {
        params: {},
      })
      .then((res) => {
        setRows(res.data.users);
      })
      .catch((err) => console.log(err));
  };

  const getDataRole = () => {
    axios
      .get(`/api/v1/roles`, {
        params: {},
      })
      .then((res) => {
        setRoles(res.data.roles);
      })
      .catch((err) => console.log(err));
  };

  const rowsWithIndex = rows.map((row, index) => ({
    index: index + 1,
    ...row,
    roleId: row.roleId == 0 ? "" : row.roleId,
  }));

  const handleOpen = (data) => {
    setOpen(true);
    if (data) {
      setFormData(data);
    }
  };

  const handleClose = (isReload) => {
    setOpen(!open);
    setFormData({});
    setErrors({});
    setIsResetPassword(false);
    if (isReload) {
      getData();
    }
  };

  const handleSelectChange = (e) => {
    setFormData({
      ...formData,
      parentId: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      const sendData = {
        // roleId: parseInt(formData.roleId, 10) || 0,
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        account: formData.account,
        password: formData.password,
      };
      axios
        .post(`/api/v1/users`, sendData)
        .then((res) => {
          toast("Thêm người dùng thành công!", {
            type: "success",
            autoClose: 1000,
          });
          handleClose(true);
        })
        .catch((err) => {
          console.log(err);
          toast("Có lỗi xảy ra!", {
            type: "error",
            autoClose: 1000,
          });
        });
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const validationErrors = await validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      const sendData = {
        // roleId: parseInt(formData.roleId, 10) || 0,
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        password: isResetPassword ? formData.password : "",
      };
      axios
        .put(`/api/v1/users/` + formData.id, sendData)
        .then((res) => {
          toast("Cập nhật người dùng thành công!", {
            type: "success",
            autoClose: 1000,
          });
          handleClose(true);
        })
        .catch((err) => {
          console.log(err);
          toast("Có lỗi xảy ra!", {
            type: "error",
            autoClose: 1000,
          });
        });
    }
  };

  const validateForm = async (data) => {
    const errors = {};

    if (!data.fullName || data.fullName.trim() === "") {
      errors.fullName = "Họ và tên không được để trống.";
    }

    if (!data.email || data.email.trim() === "") {
      errors.email = "Email không được để trống.";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(data.email)) {
        errors.email = "Email không đúng định dạng.";
      }
    }

    if (!data.phone || data.phone.trim() === "") {
      errors.phone = "Số điện thoại không được để trống.";
    } else {
      const phoneRegex = /^(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})$/;
      if (!phoneRegex.test(data.phone)) {
        errors.phone = "Số điện thoại không hợp lệ.";
      }
    }

    if (!data.address || data.address.trim() === "") {
      errors.address = "Địa chỉ không được để trống.";
    }

    if (!data.account || data.account.trim() === "") {
      errors.account = "Tên đăng nhập không được để trống.";
    }

    if (!data.account || data.account.trim() === "") {
      errors.account = "Tên đăng nhập không được để trống.";
    }

    if (!data.password || data.password.trim() === "") {
      errors.password = "Mật khẩu không được để trống.";
    } else {
      // const passwordRegex =
      //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      // if (!passwordRegex.test(data.password)) {
      //   errors.password =
      //     "Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, chữ số và ký tự đặc biệt.";
      // }
    }

    return errors;
  };

  const handleDelete = (id) => {
    if (id == userId) {
      toast("Không thể xoá chính mình", {
        type: "error",
        autoClose: 1000,
      });
      return;
    }
    swal({
      title: `Bạn muốn xóa người dùng này`,
      text: ` Lưu ý: Hành động không thể khôi phục lại`,
      icon: "warning",
      buttons: ["Đóng", "Xóa"],
      successMode: true,
    }).then((ok) => {
      if (ok) {
        axios
          .delete(`/api/v1/users/${id}`)
          .then((res) => {
            toast("Xoá người dùng thành công", {
              type: "success",
              autoClose: 1000,
            });
            getData();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const CustomInputProps = {
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          edge="end"
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ),
  };

  function generateUserCode() {
    const timestamp = Date.now().toString();
    return "USER" + timestamp.slice(-6).padStart(6, "0");
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Quản lý người dùng
      </Typography>
      <Box sx={{ marginBottom: 2, display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          color="info"
          sx={{ width: 100 }}
          onClick={handleOpen}
        >
          Thêm
        </Button>
      </Box>
      <Paper sx={{ height: 730, width: "100%" }}>
        <DataGrid
          rows={rowsWithIndex}
          columns={columns}
          initialState={{ pagination: { paginationModel } }}
          pageSizeOptions={[5, 10]}
          // checkboxSelection
          disableRowSelectionOnClick
          localeText={localeTextVietnamese}
          sx={{
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                marginBottom: 0,
              },
          }}
        />
      </Paper>

      {/* Add Edit Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              width: 800,
              p: 5,
              maxHeight: "95vh",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Typography sx={{ pb: 5 }} variant="h4" component="h2">
              {isResetPassword
                ? "Cập nhật mật khẩu mới"
                : `${formData.id ? "Sửa" : "Thêm"} người dùng`}
            </Typography>
            {!isResetPassword && (
              <Box>
                {/* <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 3,
                  }}
                >
                  <FormControl fullWidth sx={{ pb: 5 }}>
                    <InputLabel id="category-label">Phân quyền</InputLabel>
                    <Select
                      labelId="category-label"
                      value={formData.roleId ?? ``}
                      onChange={handleSelectChange}
                      label="Phân quyền"
                    >
                      {roles.map((item, idx) => (
                        <MenuItem key={idx} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label="Mã người dùng"
                    required
                    disabled
                    variant="outlined"
                    sx={{ width: "100%", paddingBottom: 5 }}
                    value={formData.userCode ?? generateUserCode()}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        userCode: e.target.value,
                      });
                      setErrors({ ...errors, userCode: "" });
                    }}
                    error={Boolean(errors.userCode)}
                    helperText={errors.userCode}
                  />
                </Box> */}
                <TextField
                  label="Họ và tên"
                  required
                  variant="outlined"
                  sx={{ width: "100%", paddingBottom: 5 }}
                  value={formData.fullName ?? ""}
                  onChange={(e) => {
                    setFormData({ ...formData, fullName: e.target.value });
                    setErrors({ ...errors, fullName: "" });
                  }}
                  error={Boolean(errors.fullName)}
                  helperText={errors.fullName}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 3,
                  }}
                >
                  <TextField
                    label="Email"
                    required
                    variant="outlined"
                    sx={{ width: "100%", paddingBottom: 5 }}
                    value={formData.email ?? ""}
                    onChange={(e) => {
                      setFormData({ ...formData, email: e.target.value });
                      setErrors({ ...errors, email: "" });
                    }}
                    error={Boolean(errors.email)}
                    helperText={errors.email}
                  />
                  <TextField
                    label="Số điện thoại"
                    required
                    variant="outlined"
                    sx={{ width: "100%", paddingBottom: 5 }}
                    value={formData.phone ?? ""}
                    onChange={(e) => {
                      setFormData({ ...formData, phone: e.target.value });
                      setErrors({ ...errors, phone: "" });
                    }}
                    error={Boolean(errors.phone)}
                    helperText={errors.phone}
                  />
                </Box>
                <TextField
                  label="Địa chỉ"
                  required
                  variant="outlined"
                  sx={{ width: "100%", paddingBottom: 5 }}
                  value={formData.address ?? ""}
                  onChange={(e) => {
                    setFormData({ ...formData, address: e.target.value });
                    setErrors({ ...errors, address: "" });
                  }}
                  error={Boolean(errors.address)}
                  helperText={errors.address}
                />
                <TextField
                  label="Tên đăng nhập"
                  required
                  disabled={Boolean(formData.id)}
                  variant="outlined"
                  sx={{ width: "100%", paddingBottom: 5 }}
                  value={formData.account ?? ""}
                  onChange={(e) => {
                    setFormData({ ...formData, account: e.target.value });
                    setErrors({ ...errors, account: "" });
                  }}
                  error={Boolean(errors.account)}
                  helperText={errors.account}
                />
              </Box>
            )}
            {!formData.id && (
              <TextField
                label="Mật khẩu"
                required
                type={showPassword ? "text" : "password"}
                slotProps={{
                  input: CustomInputProps,
                }}
                variant="outlined"
                sx={{ width: "100%", paddingBottom: 5 }}
                value={formData.password ?? ""}
                onChange={(e) => {
                  setFormData({ ...formData, password: e.target.value });
                  setErrors({ ...errors, password: "" });
                }}
                error={Boolean(errors.password)}
                helperText={errors.password}
              />
            )}

            {isResetPassword && (
              <TextField
                label="Mật khẩu"
                required
                type={showPassword ? "text" : "password"}
                slotProps={{
                  input: CustomInputProps,
                }}
                variant="outlined"
                sx={{ width: "100%", paddingBottom: 5 }}
                onChange={(e) => {
                  setFormData({ ...formData, password: e.target.value });
                  setErrors({ ...errors, password: "" });
                }}
                error={Boolean(errors.password)}
                helperText={errors.password}
              />
            )}

            <Box sx={{ display: "flex", justifyContent: "end", gap: 3 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
              >
                Trở về
              </Button>
              <Button
                variant="contained"
                color="info"
                onClick={formData.id ? handleUpdate : handleSubmit}
              >
                Lưu
              </Button>
            </Box>
          </Paper>
        </Box>
      </Modal>
    </Box>
  );
}
